import { render, staticRenderFns } from "./SearchIndexComponent.vue?vue&type=template&id=fc7458b6"
import script from "./SearchIndexComponent.vue?vue&type=script&lang=js"
export * from "./SearchIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports